// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var textStyle = BsCssJs$PrezzeeRibbon.style([
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(3)),
      BsCssJs$PrezzeeRibbon.fontWeight({
            NAME: "num",
            VAL: 400
          }),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.margin2(BsCssJs$PrezzeeRibbon.px(5), BsCssJs$PrezzeeRibbon.px(20))
    ]);

var linkStyle = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.textDecoration("underline"),
      BsCssJs$PrezzeeRibbon.textDecorationColor({
            NAME: "hex",
            VAL: "FFFFFF"
          })
    ]);

var Styles = {
  textStyle: textStyle,
  linkStyle: linkStyle
};

function AlertBanner__Text(props) {
  var optionalStyles = props.optionalStyles;
  var link = props.link;
  var mobileText = props.mobileText;
  var desktopText = props.desktopText;
  var link$1 = link !== undefined ? link : false;
  var optionalStyles$1 = optionalStyles !== undefined ? optionalStyles : "";
  var className = link$1 ? Classnames([
          textStyle,
          linkStyle,
          optionalStyles$1
        ]) : Classnames([
          textStyle,
          optionalStyles$1
        ]);
  var displayText = mobileText !== undefined ? mobileText : desktopText;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      greaterThan: "rbMobile",
                      children: JsxRuntime.jsx("p", {
                            children: desktopText,
                            className: className
                          })
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      at: "rbMobile",
                      children: JsxRuntime.jsx("p", {
                            children: displayText,
                            className: className
                          })
                    })
              ]
            });
}

var make = AlertBanner__Text;

export {
  Styles ,
  make ,
}
/* textStyle Not a pure module */
